import './LogoBlock.less';
import React from 'react';
import __ from "../../../i18n";
import routes from "../../../routing/routes";
import {Link} from "react-router-dom";
import Logo from "../../../widgets/logo/Logo";
import config from "../../../../../../config.json";


export default function LogoBlock({}) {

    return <div className="logo-block">
        <Link to={routes.home.getUrl()} aria-label={config.metadata.name}>
            <Logo/>
        </Link>
    </div>;
}
